import { ConnectorPosition } from '../../BrazilMiniMap'

const TOOLTIP_WIDTH = 264

export type CustomOffsets = { [x: string]: { x: number; y: number } }

type GetRelativeCoordinatesProps = {
  group: SVGGElement
  id: string
  containerSize: { width: number; height: number }
  tooltipEstimatedHeight?: number
  customOffsets?: CustomOffsets
}

function getRelativeCoordinates({
  group,
  id,
  containerSize,
  tooltipEstimatedHeight = 0,
  customOffsets = {}
}: GetRelativeCoordinatesProps) {
  const bbox = group.getBBox()

  const customXOffset = customOffsets[id]?.x || 0.5
  const customYOffset = customOffsets[id]?.y || 0.7

  // Anchor the tooltip under the hovered region/label
  const svgX = bbox.x + customXOffset * bbox.width
  const svgY = bbox.y + customYOffset * bbox.height

  const ctm = group.getCTM()
  const svg = group.ownerSVGElement as SVGSVGElement
  const point = svg.createSVGPoint()
  point.x = svgX
  point.y = svgY

  const screenPoint = point.matrixTransform(ctm as DOMMatrix)

  // Default anchor (center horizontal)
  let tooltipLeft = screenPoint.x - TOOLTIP_WIDTH / 2

  // Prevent overflow left
  if (tooltipLeft < 0) {
    tooltipLeft = 8 // 8px padding from left
  }

  // Prevent overflow right
  if (tooltipLeft + TOOLTIP_WIDTH > containerSize.width) {
    tooltipLeft = containerSize.width - TOOLTIP_WIDTH - 8 // 8px padding from right
  }

  const offset = 8

  // If placing tooltip below the point would overflow container height,
  // flip tooltip to appear above the point.
  let placement = ''
  let tooltipTop: number
  if (screenPoint.y + tooltipEstimatedHeight + offset > containerSize.height) {
    // flip vertically above
    tooltipTop = screenPoint.y - tooltipEstimatedHeight - offset
    placement = `bottomCenter`
  } else {
    // default below
    tooltipTop = screenPoint.y + offset
    placement = `topCenter`
  }

  return {
    x: `${tooltipLeft}px`,
    y: `${tooltipTop}px`,
    placement: placement as ConnectorPosition
  }
}

export default getRelativeCoordinates
